<template>
	<div class="phone_preview">
		<div v-if="info.videoid">
			<iframe
			style="z-index:1;"
			:src="info.videourl"
			allowfullscreen="true"
			webkit-playsinline="true"
			allowtransparency="true"
			frameborder="0"
			height="250"
			width="100%"
			controls
			controlslist="nodownload noremoteplayback"
			webkitallowfullscreen="true"
			mozallowfullscreen="true"
			x5-playsinline="true"
			>
		</iframe>
	</div>
	<div class="toppicbox" v-else>
		<!-- <van-swipe class="toppicbox" :show-indicators="false" @change="changeimg">
			<van-swipe-item v-for="(item,index) in imglist" :key="'swipe_'+index"> -->
				<img class="topimg" v-lazy="info.pic_url" @click="showImg(index)">
			<!-- </van-swipe-item>
		</van-swipe>
		<div class="piclength">{{imgindex}}/{{imgnum}}</div> -->
	</div>
	<div class="show" v-if="info">
		<h3>
			<span class="posttitle f-16">{{info.title}}</span>
		</h3>
		<div class="media">
			<span class="mr-10">{{info.media.name}}</span>
			<span>{{info.time_format}}</span>
		</div>
		<div v-html="info.content" class="content"></div>
	</div>
</div>
</template>
<script>
	import content from '../../../api/content';
	import {Swipe, SwipeItem,Row, Col, Tag,Grid, GridItem,List,Field,Button,Overlay,ActionSheet,Divider,Popup,ImagePreview,Lazyload} from "vant";
	import { mapState } from 'vuex';
	export default {
		data () {
			return {
				post_id:'',
				info: '',
				imglist:[],
				imgnum:1,
				imgIndex:0,
				imgindex:1,
				showState:false,
				img: {
					avatar: require('../../../assets/img/lexus/default.png'),
				},
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user,
				source: state => state.param.source
			})
		},
		
		created () {
			var id = this.$route.query.id
			this.$store.commit('param/show', false)
			this.$appService.isShowReturn({state: true})
			this.$appService.isTabbar({state: true})
			this.weburl=process.env.VUE_APP_URL
			this.getInfo(id)
		},
		activated () {
			this.$store.commit('param/show', false)
			this.$appService.isShowReturn({state: true})
			this.$appService.isTabbar({state: true})
		},
		methods: {
			getInfo (post_id) {
				content.getShow(post_id).then(res => {
					if(res.data.state == 1) {
						this.info = res.data.data
						this.tripartite_info=res.data.data.tripartite_info
						this.imglist=res.data.data.all_pics
						this.imgnum=this.imglist.length
						var imglist=res.data.data.all_pics
						this.imgList=[]
						for(var i=0;i<imglist.length;i++){
							this.imgList.push(imglist[i].img_url)
						}

						this.$util.title(res.data.data.title)
						if(res.data.data.title){
							document.title = res.data.data.title;
						}
					}
				})
			},
			changeimg(index){
				this.imgindex=index+1
			},
			showImg(key){
				this.imagelist =[]
				this.imagelist = this.imglist
				this.imgIndex = key
				this.showState = true
			},
			changeImg (index) {
				this.imgIndex = index
			},
			onLoad() {

			},
		},
		components: {
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem,
			[Row.name]: Row,
			[Col.name]: Col,
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[Tag.name]: Tag,
			[List.name]:List,
			[Field.name]:Field,
			[Button.name]:Button,
			[Overlay.name]:Overlay,
			[ActionSheet.name]:ActionSheet,
			[Divider.name]:Divider,
			[Popup.name]:Popup,
			[ImagePreview.name]:ImagePreview,
			[Lazyload.name]:Lazyload,
		}
	};
</script>

<style lang="scss">
.phone_preview {
	margin-bottom: 50px;
	background-color: #F0F0F0;
	.voicebox{
		height: 300px;
		background-size: 100% 300px;
		background-repeat: no-repeat;
		background-position: center;
		opacity: 0.74;
		.voicepic{
			width: 120px;
			height: 120px;
			border-radius: 8px;
			margin-top: 30px;
		}
	}

// .img{
//   width: 100%;
//   height: 250px;
//   display: block;
//   object-fit: cover;
// }
.toppicbox{
	width: 100%;
	height: 250px;
	object-fit: cover;
}
.piclength{
	width: 30px;
	float: right;
	margin-right: 10px;
	margin-top: -25px;
	position: relative;
	font-size: 10px;
	color: #fff;
	background-color: #000000;
	opacity: 0.5;
	text-align: center;
}
.topimg{
	width: 100%;
	height: 250px;
	margin-bottom: 20px;
	object-fit: cover;
}
.posttitle{
	vertical-align: middle;
	word-break:break-all;
}
.mr-10{
	margin-right: 10px;
}
.show {
	padding: 10px;
	background-color: #FFF;
	font-size: 14px;
	color: #3A3A3A;

	h3 {
		font-size: 16px;
		margin: 0;
	}

	.mt-40{
		margin-top: 40px;
	}
	.media {
		color: #9A9A9A;
		font-size: 12px;
		margin: 10px 0;
		img {
			width: 30px;
			border-radius: 15px;
			vertical-align: middle;
		}
	}
	.content {
		margin-top: 0px;
		font-size: 14px !important;
		line-height: 2 !important;
		word-break:break-all;
		img {
			max-width: 100%;
			object-fit:cover;
			line-height: 0 !important;
		}
		iframe{
			max-width: 100%;
		}
		video{
			max-width: 100%;
		}
	}
	.content iframe{
		width: 100%;
		height: 200px;
	}
	.content video{
		width: 100%;
		height: 200px;
	}
	.applet_pic{
		max-width: 100%;
	}
	.parise {
		text-align: center;
		margin: 30px 0 50px 0;

		a {
			color: #3A3A3A;
			font-size: 11px;
			display: inline-block;
			width: 110px;
			height: 35px;
			line-height: 35px;
			border-radius: 2px;
			margin: 0 7px;
			box-sizing: border-box;
			background-color: #F3F9FF;
			border: none;
			img {
				width: 15px;
				height: 14px;
				vertical-align: middle;
				margin-right: 7px;
			}
		}
	}
}
.recommend {
	padding: 10px;
	border-top: 1px solid #EAEAEA;
	background-color: #fff;
	margin-top: 10px;
	h3 {
		font-size: 13px;
	}
	img {
		width: 100%;
		height: 100px;
// border-radius: 3px;
display: block;
object-fit: cover;
}
h2 {
	font-size: 16px;
	margin: 0;
	color: #3A3A3A;
	font-weight: 400;
	.van-tag {
		font-weight: normal;
	}
}
.van-row {
	margin-bottom: 10px;
}

.picthere{
	width: 100%;
	height: auto;
}
.van-grid-item__content{
	padding: 10px 0;
}
}
.borderleft{
	margin-right: 10px;
	border-left: 3px solid #3A3A3A;
}
.comments {
	background-color: #FFF;
	margin-top: 10px;

	h2 {
		font-size: 14px;
		font-weight: bold;
		padding: 15px 10px;
		border-bottom: 1px solid #f8f8f8;
		margin: 0;
	}
	.comment {
// margin: 0 10px;
overflow: hidden;
.van-row {
	padding: 5px 0;
}
.btn-bor{
	padding: 10px;
	border-bottom: 1px solid #f8f8f8;
}
.avatar {
	width: 40px;
	height: 40px;
	object-fit: cover;
	border-radius: 1.5px;
}
.infohand_box{
	width:40px;
	height:45px;
	position: relative;
}
.infohand_border{
	width:40px;
	height:40px;
	position: absolute;
	left: 0;
}
.user_info {
	font-size: 15px;
	font-weight: bold;
	color: #605c6b;
	display: flex;
	align-items: center;
	height: 40px;
	.van-ellipsis{
		flex: 1;
		display: inline-block;
	}
	.mycars{
		display: flex;
		align-items: center;
		font-size: 12px;
		font-weight: 400;
		color: #9A9A9A;
		vertical-align: middle
	}
	.binbox {
		color: #9A9A9A;
		font-size: 12px;
		float: right;
		font-weight: normal;

		img {
			width: 15px;
			height: 14px;
			margin-right: 11px;
			vertical-align: middle;
		}
		.sourtime{
			font-size: 12px;
			color: #9A9A9A;
			vertical-align: middle;
			font-weight: 300;
		}
	}
}
p {
	font-size: 13px;

	.c-blue {
		font-style: normal;
	}
	&.time {
		font-size: 12px;
		color: #9A9A9A;

		span {
			margin-left: 5px;
		}
	}
}
.headimg {
	width: 25px;
	border-radius: 1.5px;
}
.headimg_box{
	width:25px;
	height:25px;
	position: relative;
}
.headimg_border{
	width:25px;
	height:25px;
	position: absolute;
	left: 0;
}
.replys {
	.van-row {
		font-size: 13px;
	}
	.pd-5{
		padding: 0 5px;
	}

}
}
}
a{
	color: #3A3A3A;
}
iframe{
	width: 100%;
	height: 210px;
}
.van-popup{
	.van-action-sheet__cancel::before{
		height: 1px;
	}
	.divider{
		margin: 20px 80px;
	}
}
}
</style>
